export default __webpack_public_path__ + "static/media/pc.966c9179.png";